import React from 'react';
import { Icon } from './Icon.js';
export const IconLabelMinus = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M19 13V8.50001L12 1.5L5 8.50001L5 21H9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 8.00708L12.0071 8.00001", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13 18H21", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconLabelMinus.js.map